import Navbar from "./navbar"
import Sidebar from "./sidebar"

interface LayoutProps {
  children: React.ReactNode
  currentPath?: string
}

const Layout = ({ children, currentPath = '' }: LayoutProps) => {
  return (
    <div className="min-h-screen bg-gray-50">
      {/* Header */}
      <Navbar />
      <div className="flex">
        {/* Sidebar */}
        <Sidebar currentPath={currentPath} />
        {/* Main Content */}
        <main className="flex-1 ml-64 mt-16 p-6 overflow-hidden">{children}</main>
      </div>
    </div>
  )
}

export default Layout